var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDvSlider2 = function SvgDvSlider2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58451",
    transform: "translate(-969 -49)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58429",
    transform: "translate(939)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 480,
    "data-name": "Rectangle 33676",
    rx: 5,
    transform: "translate(30 49)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131313",
    d: "M30 132h920v55H30z",
    "data-name": "Rectangle 33677"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "OPG TEST E2E",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 21,
    transform: "translate(218 170)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -132.951,
    y: 0
  }, "OPG TEST E2E")), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 38,
    fill: "#f3b840",
    "data-name": "Rectangle 33678",
    rx: 4,
    transform: "translate(733 140)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1a1a1a",
    "data-name": "Go to the Dashboard",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(829 165)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -83.344,
    y: 0
  }, "Go to the Dashboard"))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    "data-name": "Group 58430"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1834.5 78.5h22.167",
    "data-name": "Line 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.5 87.5h22.167",
    "data-name": "Line 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.5 96.5h22.167",
    "data-name": "Line 3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    "data-name": "Group 58431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.5 154h1.979",
    "data-name": "Line 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.5 161.125h1.979",
    "data-name": "Line 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.5 168.25h1.979",
    "data-name": "Line 3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffb501",
    "data-name": "Group 4823"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1068.107 77.73h-6.79v21.026h-2.759V77.73h-6.77v-2.494h16.319Z",
    "data-name": "Path 13634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.004 98.756h-3.051l-2.493-6.593h-9.971l-2.345 6.593h-3.068l9.02-23.519h2.854Zm-6.446-9.07-3.691-10.021a9.7 9.7 0 0 1-.359-1.575h-.066a8.7 8.7 0 0 1-.378 1.575l-3.657 10.021Z",
    "data-name": "Path 13635"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffb501",
    "data-name": "Group 4824"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1041.076 109.502h-1.158l-.947-2.293h-3.787l-.891 2.293h-1.165l3.427-8.18h1.083Zm-2.448-3.154-1.4-3.486a3 3 0 0 1-.137-.548h-.025a2.7 2.7 0 0 1-.144.548l-1.387 3.486Z",
    "data-name": "Path 13636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.024 109.502h-4.633v-8.18h1.046v7.314h3.587Z",
    "data-name": "Path 13637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.313 101.322v.821h-.872v6.538h.872v.821h-2.791v-.821h.872v-6.538h-.872v-.821Z",
    "data-name": "Path 13638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.789 109.502v-8.18h2.469q4.72 0 4.72 3.987a3.85 3.85 0 0 1-1.312 3.044 5.13 5.13 0 0 1-3.509 1.149Zm1.047-7.312v6.446h1.331a4 4 0 0 0 2.736-.862 3.08 3.08 0 0 0 .977-2.441q0-3.144-3.65-3.143Z",
    "data-name": "Path 13639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.648 109.502h-1.157l-.948-2.293h-3.786l-.891 2.293h-1.168l3.427-8.18h1.083Zm-2.448-3.154-1.4-3.486a3 3 0 0 1-.137-.548h-.025a3 3 0 0 1-.144.548l-1.388 3.486Z",
    "data-name": "Path 13640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.244 102.19h-2.58v7.312h-1.046v-7.312h-2.573v-.868h6.2Z",
    "data-name": "Path 13641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.246 109.639a4.1 4.1 0 0 1-3.043-1.147 4.04 4.04 0 0 1-1.143-2.983 4.034 4.034 0 0 1 4.335-4.323 4 4 0 0 1 2.98 1.14 4.05 4.05 0 0 1 1.132 2.983 4.3 4.3 0 0 1-1.16 3.166 4.18 4.18 0 0 1-3.101 1.164m.074-7.586a3 3 0 0 0-2.285.929 3.854 3.854 0 0 0-.023 4.874 2.9 2.9 0 0 0 2.234.922 3.07 3.07 0 0 0 2.318-.879 3.4 3.4 0 0 0 .846-2.459 3.53 3.53 0 0 0-.822-2.5 2.94 2.94 0 0 0-2.268-.887",
    "data-name": "Path 13642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.667 109.502h-1.246l-1.5-2.293a5 5 0 0 0-.4-.544 2.2 2.2 0 0 0-.395-.369 1.4 1.4 0 0 0-.437-.208 2 2 0 0 0-.525-.066h-.854v3.48h-1.047v-8.18h2.666a4.1 4.1 0 0 1 1.08.134 2.5 2.5 0 0 1 .859.408 1.9 1.9 0 0 1 .57.681 2.3 2.3 0 0 1 .066 1.739 2 2 0 0 1-.4.636 2.4 2.4 0 0 1-.622.477 3.3 3.3 0 0 1-.82.3v.023a1.9 1.9 0 0 1 .7.485 4 4 0 0 1 .3.362q.148.202.326.47Zm-5.357-7.312v2.966h1.42a2.3 2.3 0 0 0 .725-.108 1.7 1.7 0 0 0 .576-.311 1.4 1.4 0 0 0 .38-.5 1.5 1.5 0 0 0 .137-.659 1.23 1.23 0 0 0-.463-1.024 2.12 2.12 0 0 0-1.342-.367Z",
    "data-name": "Path 13643"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb501",
    d: "M1054.031 98.473h-2.928l-2.392-6.327h-10.765l1.082-2.376h8.818l-3.542-9.616a8.3 8.3 0 0 1-.308-1.291l1.35-2.959 8.686 22.568Zm-12.264-14.708 1.979-4.356a6 6 0 0 1-.213.744Z",
    "data-name": "Subtraction 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1006.637 115.232h-12.516V68h13.042a37.5 37.5 0 0 1 10.923 1.439 20.05 20.05 0 0 1 7.8 4.317 17.94 17.94 0 0 1 4.681 7.194 29.7 29.7 0 0 1 1.56 10.072 31 31 0 0 1-.214 3.709q-1.379 1.877-2.756 3.756c-.33.45-.577.643-.828.643-.23 0-.472-.163-.784-.528q-.871-1.019-1.744-2.033a26.2 26.2 0 0 0 .53-5.416c0-6.021-1.623-10.6-4.825-13.611s-8.07-4.536-14.473-4.536h-7.378v37.219h7.047c6.163 0 11.028-1.673 14.46-4.974.136-.13.272-.267.405-.4l2.436 4.812a23 23 0 0 1-7.7 4.18 31.7 31.7 0 0 1-9.666 1.389",
    "data-name": "Subtraction 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb501",
    d: "M1028.407 112.614c-.646.019-1.151-.447-1.536-1.335q-3.285-7.572-6.557-15.159a2.52 2.52 0 0 1-.021-2.151c.3-.617.762-.676 1.183-.111 2.122 2.839 4.246 5.67 6.352 8.549.34.463.54.421.848-.07 3.62-5.772 11.892-20.427 15.52-26.178.567-.9 1.292-.628 1.428.621a3.56 3.56 0 0 1-.24 1.563c-1.867 4.211-8.4 17.288-10.285 21.467q-2.529 5.6-5.055 11.21c-.442.982-.953 1.635-1.637 1.594",
    "data-name": "Path 13648"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    "data-name": "Group 58432"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998.833 154h12.667",
    "data-name": "Line 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.833 161.125h12.667",
    "data-name": "Line 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.833 168.25h12.667",
    "data-name": "Line 3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M969 184h290v345H974a5 5 0 0 1-5-5z",
    "data-name": "Rectangle 33679"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M1284 184h290v345h-290z",
    "data-name": "Rectangle 33680"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M1599 184h290v340a5 5 0 0 1-5 5h-285z",
    "data-name": "Rectangle 33681"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343642",
    d: "M1259 184h25v345h-25z",
    "data-name": "Rectangle 33682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343642",
    d: "M1574 184h25v345h-25z",
    "data-name": "Rectangle 33683"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 215.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 214)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "responseid")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 240.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 239)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "respid")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 266.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 265)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "status")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 293.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 292)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "interview")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 320.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 319)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ip")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 346.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 345)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "version")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 373.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 372)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "st")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 401.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 400)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "s0")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 428.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 427)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "qintro")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 455.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 454)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "qae")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 482.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 481)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "qitx1")), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M997 509.278a1.375 1.375 0 0 1-1.25 1.472h-10a1.375 1.375 0 0 1-1.25-1.472v-10.306a1.375 1.375 0 0 1 1.25-1.472h3.125l1.25 2.208h5.625a1.375 1.375 0 0 1 1.25 1.473Z",
    "data-name": "8666803_folder_documents_icon"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#676767",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1004 508)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "qi1xde")), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 339,
    fill: "#6f6f6d",
    "data-name": "Rectangle 33684",
    rx: 3.5,
    transform: "translate(1250 187)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 188,
    fill: "#929292",
    "data-name": "Rectangle 33685",
    rx: 2.5,
    transform: "translate(1251 187)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#c8c8c8",
    "data-name": "1 23 45 67 89 10 11 12 13 14 15 16",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 12,
    fontWeight: 500,
    transform: "translate(1612 210)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 84
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 105
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 126
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 147
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 168
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 189
  }, "10"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 210
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 231
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 252
  }, "13"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 273
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 294
  }, "15"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 315
  }, "16")), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 339,
    fill: "#6f6f6d",
    "data-name": "Rectangle 33686",
    rx: 3.5,
    transform: "translate(1877 187)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 188,
    fill: "#929292",
    "data-name": "Rectangle 33687",
    rx: 2.5,
    transform: "translate(1878 187)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#c8c8c8",
    "data-name": "var list = obj.GetAllRecords(); for (int i = 0; i < list.Rows.Count; i++) { obj.initialize(i); obj.f(\"b5b\").NUMGValid(\"{c0=1}\",\"1:6\" }//obj.f(\"q16\").OEValid(//obj.f(\"q16\").OEValid(// Section j // J1 // q0W1",
    fontFamily: "Helvetica",
    fontSize: 14,
    transform: "translate(1640 210)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "var list = obj.GetAllRecords"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#f3b840"
  }, "()"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ";"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3566ae"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    y: 21,
    fill: "#f3b840"
  }, " ("), /*#__PURE__*/React.createElement("tspan", {
    y: 21
  }, "int "), /*#__PURE__*/React.createElement("tspan", {
    y: 21,
    fill: "#c8c8c8"
  }, "i = 0; i < list.Rows.Count; i++"), /*#__PURE__*/React.createElement("tspan", {
    y: 21,
    fill: "#f3b840"
  }, ")")), /*#__PURE__*/React.createElement("tspan", {
    fill: "#f3b840"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42
  }, "{")), /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    x: 0,
    y: 63
  }, " obj.initialize"), /*#__PURE__*/React.createElement("tspan", {
    y: 63,
    fill: "#be38a3"
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    y: 63
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    y: 63,
    fill: "#be38a3"
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    y: 63
  }, ";"), /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    x: 0,
    y: 84
  }, " obj.f"), /*#__PURE__*/React.createElement("tspan", {
    y: 84,
    fill: "#be38a3"
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    y: 84,
    fill: "#f3b840"
  }, "\"b5b\""), /*#__PURE__*/React.createElement("tspan", {
    y: 84,
    fill: "#be38a3"
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    y: 84
  }, ".NUMGValid"), /*#__PURE__*/React.createElement("tspan", {
    y: 84,
    fill: "#be38a3"
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    y: 84,
    fill: "#f3b840"
  }, "\"{c0=1}\",\"1:6\""), /*#__PURE__*/React.createElement("tspan", {
    fill: "#f3b840"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 105
  }, "}"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 147
  }, "//obj.f(\"q16\").OEValid("), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 189
  }, "//obj.f(\"q16\").OEValid("), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 273
  }, "// Section j"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 294
  }, "// J1"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 315
  }, "// q0W1"))))));
};
export default SvgDvSlider2;